import axios from "../utils/axios";

export const getOrganizationalStructure = async () => {
    const { data } = await axios.get(`/chart`);
    return data;
};